import z from "zod";
export var MhaStatus;
(function (MhaStatus) {
    MhaStatus["Unknown"] = "Unknown";
    MhaStatus["NotDetained"] = "Not Detained";
    MhaStatus["Incomplete"] = "Incomplete";
    MhaStatus["Expired"] = "Expired";
    MhaStatus["Section2"] = "Section 2";
    MhaStatus["Section3"] = "Section 3";
    MhaStatus["Section4"] = "Section 4";
    MhaStatus["Section5_2"] = "Section 5(2)";
    MhaStatus["Section5_4"] = "Section 5(4)";
    MhaStatus["Section17A"] = "Section 17A";
    MhaStatus["Section136"] = "Section 136";
})(MhaStatus || (MhaStatus = {}));
export const MhaStatusSchema = z.enum({
    Unknown: "Unknown",
    NotDetained: "Not Detained",
    Incomplete: "Incomplete",
    Expired: "Expired",
    Section2: "Section 2",
    Section3: "Section 3",
    Section4: "Section 4",
    Section5_2: "Section 5(2)",
    Section5_4: "Section 5(4)",
    Section17A: "Section 17A",
    Section136: "Section 136",
});
export const DetainedStatuses = [
    MhaStatus.Section5_4,
    MhaStatus.Section5_2,
    MhaStatus.Section4,
    MhaStatus.Section2,
    MhaStatus.Section17A,
    MhaStatus.Section3,
    MhaStatus.Section136,
    MhaStatus.NotDetained,
];
/**
 * The non-Section-136 MHA statuses that can co-exist with an active
 * Section 136 to produce a dual-status patient. Intermediary statuses
 * (Unknown, Incomplete, Expired, Discharged, NotDetained) are excluded
 * — Section 136 alongside any of those is a single-status patient.
 */
export const InScopeNonSection136Detentions = [
    MhaStatus.Section17A,
    MhaStatus.Section2,
    MhaStatus.Section3,
    MhaStatus.Section4,
    MhaStatus.Section5_2,
    MhaStatus.Section5_4,
];
/**
 * "Intermediary" statuses — placeholders for "no active real status".
 * They should never remain `isLatest` alongside a real detention: when a
 * real status arrives, any prior intermediary latest row is flipped off.
 * (Discharge is recorded as NotDetained + DischargeReason, so NotDetained
 * appears here too.)
 */
export const IntermediaryStatuses = [
    MhaStatus.Unknown,
    MhaStatus.Incomplete,
    MhaStatus.Expired,
    MhaStatus.NotDetained,
];
export var DischargeReason;
(function (DischargeReason) {
    DischargeReason["Section23"] = "Section 23";
    DischargeReason["HoldingPowersDischarge"] = "Holding Powers Discharge";
    DischargeReason["SectionExpired"] = "Section Expired";
    DischargeReason["TribunalOrNearestRelative"] = "Discharged by Tribunal/Nearest Relative";
    // A Section 136 that ended without further detention: recorded by
    // completing the Section 136 outcome form with a discharge outcome (e.g.
    // "Discharge with mental health follow up"), or by a manual edit.
    DischargeReason["Section136Outcome"] = "Section 136 Outcome";
    DischargeReason["Other"] = "Other";
})(DischargeReason || (DischargeReason = {}));
/**
 * Whether this is a discharge that ended a Section 136. The patient was held at
 * a place of safety rather than a hospital, so the place of safety is recorded
 * where other discharges record a hospital.
 */
export const isSection136Discharge = (status, dischargeReason) => status === MhaStatus.NotDetained &&
    dischargeReason === DischargeReason.Section136Outcome;
//# sourceMappingURL=PatientState.js.map